import { render, staticRenderFns } from "./consultProcessbanli.vue?vue&type=template&id=a13fbef2&scoped=true&"
import script from "./consultProcessbanli.vue?vue&type=script&lang=js&"
export * from "./consultProcessbanli.vue?vue&type=script&lang=js&"
import style0 from "./consultProcessbanli.vue?vue&type=style&index=0&id=a13fbef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13fbef2",
  null
  
)

export default component.exports